import * as React from "react";

/**
 * Adia a montagem de um pedaço de "cromo" (aviso de cookies, por exemplo) para
 * depois da primeira tela.
 *
 * Usado pelas cascas leves (`EntradaApp`, `PublicoApp`): o aviso é obrigatório
 * (o Pixel só dispara com consentimento), mas arrasta primitivas de UI e o
 * cliente do Supabase — banda disputando com o conteúdo pelo qual pagamos o
 * clique. Montado na ociosidade, aparece um instante depois e a mãe consente do
 * mesmo jeito.
 */
export function useMontarDepois(msPadrao = 1200): boolean {
  const [pronto, setPronto] = React.useState(false);
  React.useEffect(() => {
    const idle = (
      window as Window & {
        requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number;
      }
    ).requestIdleCallback;
    if (typeof idle === "function") {
      idle(() => setPronto(true), { timeout: msPadrao });
      return;
    }
    const t = window.setTimeout(() => setPronto(true), msPadrao);
    return () => window.clearTimeout(t);
  }, [msPadrao]);
  return pronto;
}
